<template>
  <div class="wrapp">
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div v-else style="overflow: auto;">
      <div class="row">
        <div class="col-12">
          <h2>Visualizar Cadastro</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <h6>Nome</h6>
          <p>{{ user.name || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>E-mail</h6>
          <p>{{ user.email || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>Telefone</h6>
          <p>{{ user.celphone || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>CPF</h6>
          <p>{{ user.cpf || '-' }}</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <h6>Data de Nascimento</h6>
          <p>{{ formatDate(user.birthday, true) }}</p>
        </div>
        <div class="col-3">
          <h6>Cargo</h6>
          <p>{{ user.occupation || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>Departamento</h6>
          <p>{{ user.department || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>Cidade</h6>
          <p>{{ user.city || '-' }}</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <h6>CNPJ</h6>
          <p>{{ user.cnpj || '-' }}</p>
        </div>
        <div class="col-3">
          <h6>Cadastro</h6>
          <p>{{ formatDate(user.createdAt) }}</p>
        </div>
        <div class="col-3">
          <h6>Último Acesso</h6>
          <p>{{ formatDate(user.last_access) }}</p>
        </div>
        <div class="col-3">
          <h6>Status</h6>
          <b-form-select
            @change="changeStatus"
            v-model="user.active"
            :options="options"
            size="sm"
          ></b-form-select>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <h6>Notificar Oferta/Procura</h6>
          <b-form-select
            @change="changeNotify"
            v-model="user.notify"
            :options="optionsNotify"
            size="sm"
          ></b-form-select>
        </div>
        <div v-if="userAuth.type=='master'" class="col-3">
          <h6>Enriquecimento de Dados</h6>
          <b-form-select
            @change="changeEnhancement"
            v-model="user.enhancement"
            :options="optionsEnhancement"
            size="sm"
          ></b-form-select>
        </div>
        <div v-if="userAuth.type=='master'" class="col-3">
          <h6>SFAT</h6>
          <b-form-select
            @change="changeSfat"
            v-model="user.sfat"
            :options="optionsSfat"
            size="sm"
          ></b-form-select>
        </div>
        <div v-if="userAuth.type=='master'" class="col-3">
          <h6>Data Inicial</h6>
          <b-form-input
            class="inputDate"
            id="initialDate"
            type="date"
            v-model="initialDate"
            required
            @change="changeInitialDate"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <h6>Dealers Associados</h6>
          <div class="dealers-area mt-3">
            <div class="dealers">
              <div class="chips-columns">
                <div v-for="(dealer, i) in user.dealers" :key="i">
                  <div ref="chip" class="chip">
                    {{ dealer.name }}
                    <span
                      @click="removeUserDealer(user.id, dealer.id)"
                      class="closebtn"
                      >&times;</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.userAreas" class="row mt-4">
        <div class="col-12">
          <h6>Áreas Operacionais Associadas</h6>
          <div class="dealers-area mt-3">
            <div class="dealers">
              <div class="chips-columns">
                <div v-for="(dealerMB, i) in userAreas" :key="i">
                  <div ref="chip" class="chip">
                    {{ getDealerMBName(dealerMB) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <h6>Segmentos Associados</h6>
          <div class="dealers-area mt-3">
            <div class="dealers">
              <div class="chips-columns">
                <div v-for="(segment, i) in userSegments" :key="i">
                  <div ref="chip" class="chip">
                    {{ segment.descricao }}
                    <span
                      @click="removeUserSegment(segment.id)"
                      class="closebtn"
                      >&times;</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <h6>Marcas Associadas</h6>
          <div class="dealers-area mt-3">
            <div class="dealers">
              <div class="chips-columns">
                <div v-for="(marca, i) in userMarcas" :key="i">
                  <div ref="chip" class="chip">
                    {{ marca.descricao }}
                    <span
                      @click="removeUserMarca(marca.id)"
                      class="closebtn"
                      >&times;</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mt-3">
        <div class="col-12 text-right">
          <button v-b-modal.modal-dealers class="btn btn-outline-primary">
            Adicionar Dealers
          </button>
          <button
            v-if="userAuth.type=='master'"
            v-b-modal.modal-segments class="btn btn-outline-primary ml-2"
          >
            Segmentos
          </button>
          <button
            v-if="userAuth.type=='master'"
            v-b-modal.modal-marcas class="btn btn-outline-primary ml-2"
          >
            Marcas
          </button>
          <button
            v-b-modal.change-password
            class="btn btn-outline-primary ml-2"
          >
            Mudar senha
          </button>
          <b-modal
            @ok="userChangePassword($route.params.id)"
            id="change-password"
            title="Modificar senha do usuário"
          >
            <div class="form-group">
              <input
                v-model="password"
                type="password"
                class="form-control"
                placeholder="Nova Senha"
              />
            </div>

            <div class="form-group">
              <input
                v-model="cPassword"
                type="password"
                class="form-control"
                placeholder="Confirme a Nova Senha"
              />
            </div>
          </b-modal>
          <button
            v-b-modal.modal-edit-user
            class="btn btn-outline-primary ml-2"
          >
            Editar Usuário
          </button>
        </div>
      </div>
      <modal-dealers :userDealers="user.dealers" :userId="$route.params.id" />
      <modal-segments :userSegments="userSegments" :userId="$route.params.id" />
      <modal-marcas :userMarcas="userMarcas" :userId="$route.params.id" />
      <modal-edit-user :user="user" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { lightFormat } from 'date-fns';
import axios from 'axios';
import ModalDealers from '../../../../organisms/modal-dealers/index.vue';
import ModalSegments from '../../../../organisms/modal-segments/index.vue';
import ModalMarcas from '../../../../organisms/modal-marcas/index.vue';
import ModalEditUser from '../../../../organisms/modal-edit-user/index.vue';
import EventBus from '../../../../../eventBus';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  components: {
    ModalDealers,
    ModalEditUser,
    ModalSegments,
    ModalMarcas,
  },

  data: () => ({
    userAuth: null,
    selected: 'ativo',
    loading: true,
    user: null,
    options: [
      { value: 'active', text: 'Ativo' },
      { value: 'pending', text: 'Aguardando' },
    ],
    optionsNotify: [
      { value: false, text: 'Não' },
      { value: true, text: 'Sim' },
    ],
    optionsEnhancement: [
      { value: false, text: 'Não' },
      { value: true, text: 'Sim' },
    ],
    optionsSfat: [
      { value: false, text: 'Não' },
      { value: true, text: 'Sim' },
    ],
    dealersIds: [],
    segmentoList: [],
    userSegments: [],
    marcaList: [],
    userMarcas: [],
    areasOperacionais: [],
    userAreas: [],
    password: null,
    cPassword: null,
    initialDate: null,
  }),

  computed: {
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
    await this.getUser({
      token: this.userAuth.token,
      id: this.$route.params.id,
    });
    this.initialDate = this.user.initial_date;
    if (this.initialDate) {
      this.initialDate = this.initialDate.replace(/\//g, '-');
    }
    await this.carregaSegmentos();
    await this.carregaMarcas();
    await this.getUserSegments();
    await this.getUserMarcas();
    await this.getAreasOperacionais();

    this.loading = false;
  },

  async mounted() {
    EventBus.$on('saveUserDealers', async (dealers) => {
      this.loading = true;

      const dealersIds = [];

      dealers.forEach((el) => {
        dealersIds.push(el.id);
      });

      try {
        await this.updateUserDealers({
          token: this.userAuth.token,
          userId: this.user.id,
          dealersIds,
        });

        this.$swal(
          'Sucesso!',
          'Os novos dealers foram associados ao usuário.',
          'success',
        );
        await this.getUser({
          token: this.userAuth.token,
          id: this.$route.params.id,
        });
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }

      this.loading = false;
    });

    EventBus.$on('saveUserInfo', async (userEdited) => {
      this.loading = true;
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: { ...userEdited },
        });
        this.$swal(
          'Sucesso!',
          'As informações do usuário foram salvas.',
          'success',
        );
        await this.getUser({
          token: this.userAuth.token,
          id: this.$route.params.id,
        });
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
      this.loading = false;
    });

    EventBus.$on('saveUserSegments', async (segmentsIds) => {
      this.loading = true;
      try {
        await this.updateUserSegments({
          id: this.user.id,
          segmentsIds,
        });
        this.$swal(
          'Sucesso!',
          'Segmentos associados ao usuário.',
          'success',
        );
        await this.getUser({
          token: this.userAuth.token,
          id: this.$route.params.id,
        });
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
      this.loading = false;
    });

    EventBus.$on('saveUserMarcas', async (marcasIds) => {
      this.loading = true;
      try {
        await this.updateUserMarcas({
          id: this.user.id,
          marcasIds,
        });
        this.$swal(
          'Sucesso!',
          'Marcas associadas ao usuário.',
          'success',
        );
        await this.getUser({
          token: this.userAuth.token,
          id: this.$route.params.id,
        });
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
      this.loading = false;
    });
  },

  methods: {
    ...mapActions('users', ['updateUser', 'updateUserDealers']),
    ...mapActions('settings', ['changePassword']),
    ...mapActions('dealers', ['removeDealer']),

    async getUser(obj) {
      try {
        const { data } = await axios.get(`${url}/user/${obj.id}`, {
          headers: { 'x-access-token': obj.token },
        });
        this.user = data;
        this.userAreas = [];
        for (let i = 0; i < this.user.dealers.length; i += 1) {
          this.userAreas.push(this.user.dealers[i].operational_area);
        }
        this.userAreas = [...new Set(this.userAreas)];
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },
    async getAreasOperacionais() {
      try {
        const { data } = await axios.get(`${url}/dealersMB`, {
          headers: {
            'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
          },
        });
        this.areasOperacionais = data;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async getUserSegments() {
      try {
        const { data } = await axios.get(`${url}/segments/${this.user.id}`);
        this.userSegments = data;
        for (let i = 0; i < this.userSegments.length; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          this.userSegments[i].descricao = await this.getSegmentName(
            this.userSegments[i].segmentId,
          );
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async updateUserSegments(obj) {
      try {
        await axios.put(`${url}/segments`,
          { id: obj.id, segmentList: obj.segmentsIds });
        await this.loadPageInfo();
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async removeUserSegment(id) {
      try {
        await axios.delete(`${url}/segments/${id}`);
        await this.loadPageInfo();
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async carregaSegmentos() {
      try {
        const { data } = await axios.get(`${url}/dados/segmentos`, {
          headers: {
            'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
          },
        });
        this.segmentoList = data;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async getUserMarcas() {
      try {
        const { data } = await axios.get(`${url}/marcas/${this.user.id}`);
        this.userMarcas = data;
        for (let i = 0; i < this.userMarcas.length; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          this.userMarcas[i].descricao = await this.getMarcaName(
            this.userMarcas[i].marcaId,
          );
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async updateUserMarcas(obj) {
      try {
        await axios.put(`${url}/marcas`,
          { id: obj.id, marcaList: obj.marcasIds });
        await this.loadPageInfo();
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async removeUserMarca(id) {
      try {
        await axios.delete(`${url}/marcas/${id}`);
        await this.loadPageInfo();
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async carregaMarcas() {
      try {
        const { data } = await axios.get(`${url}/dados/marcas`, {
          headers: {
            'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
          },
        });
        this.marcaList = data;
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async changeStatus() {
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: {
            active: this.user.active,
          },
        });

        this.$swal('Sucesso!', 'O status do usuário foi alterado.', 'success');
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async changeNotify() {
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: {
            notify: this.user.notify,
          },
        });

        this.$swal('Sucesso!', 'Notificação para usuário foi alterada.', 'success');
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async changeEnhancement() {
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: {
            enhancement: this.user.enhancement,
          },
        });

        this.$swal('Sucesso!', 'Enriquecimento de dados para usuário foi alterada.', 'success');
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async changeSfat() {
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: {
            sfat: this.user.sfat,
          },
        });

        this.$swal('Sucesso!', 'Permissão para SFAT de usuário foi alterada.', 'success');
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async changeInitialDate() {
      try {
        await this.updateUser({
          token: this.userAuth.token,
          userId: this.user.id,
          data: {
            initial_date: this.initialDate.replace(/-/g, '/'),
          },
        });

        this.$swal('Sucesso!', 'Data Inicial para usuário foi alterada.', 'success');
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async removeUserDealer(userId, dealerId) {
      try {
        await this.removeDealer({
          token: this.userAuth.token,
          userId,
          dealerId,
        });
        this.$swal('Sucesso!', 'Dealer desassociado ao usuário.', 'success');
        await this.loadPageInfo();
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    formatDate(date, justDate) {
      if (date) {
        if (justDate) {
          let myDate = new Date(date);
          myDate = myDate.setDate(myDate.getDate() + 1);
          return lightFormat(myDate, 'dd/MM/yyyy');
        }
        return lightFormat(new Date(date), 'dd/MM/yyyy HH:mm');
      }
      return '-';
    },

    getSegmentName(id) {
      for (let i = 0; i < this.segmentoList.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.segmentoList[i].segmento == id) {
          return this.segmentoList[i].descricao;
        }
      }
      return null;
    },

    getMarcaName(id) {
      for (let i = 0; i < this.marcaList.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.marcaList[i].marca == id) {
          return this.marcaList[i].descricao;
        }
      }
      return null;
    },

    getDealerMBName(id) {
      for (let i = 0; i < this.areasOperacionais.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.areasOperacionais[i].carop == id) {
          return this.areasOperacionais[i].dcarop;
        }
      }
      return null;
    },

    async userChangePassword(id) {
      if (this.password === this.cPassword) {
        await this.changePassword({
          token: this.userAuth.token,
          userId: id,
          data: {
            password: this.password,
          },
        });

        this.$swal(
          'Senha Alterada!',
          'A senha do usuário foi alterada com sucesso!',
          'success',
        );
      } else {
        this.$swal('Senhas diferentes!', 'Tente novamente!', 'warning');
      }
    },

    async loadPageInfo() {
      this.loading = true;
      await this.getUser({
        token: this.userAuth.token,
        id: this.$route.params.id,
      });
      await this.getUserSegments();
      await this.getUserMarcas();
      this.loading = false;
    },
  },

  beforeDestroy() {
    EventBus.$off('saveUserDealers');
    EventBus.$off('saveUserInfo');
    EventBus.$off('saveUserSegments');
    EventBus.$off('saveUserMarcas');
  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  background-color: #f1f1f1;
  max-height: calc(100vh - 72px);
  overflow: auto;
}

.input-area {
  display: flex;
  flex-direction: row;
}

.save-icon {
  font-size: 21px;
  cursor: pointer;
  margin-top: 5px;
}

.chip {
  padding: 3px 15px;
  font-size: 10px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: #303030;
  color: #fff;
  display: flex;
  align-items: center;
}

.dealers {
  max-height: 303px;
  overflow: auto;
}

.chips-columns {
  // height: 40px;
}

.closebtn {
  padding-left: 10px;
  color: #fff;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
#initialDate {
  height: 30px;
  padding-top: 2px;
}

</style>
